import React, {useState, useMemo, useEffect} from 'react';
import styles from './EditMyProfile.module.css';
import XIcon from '../svgs/XIcon';
import {Paper, Toolbar, IconButton, makeStyles, Typography,} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import CheckIcon from '../svgs/CheckIcon';
import ChevronRightIcon from '../svgs/ChevronRightIcon'
import LocationIcon from '../svgs/LocationIcon';
import FlagIcon from '../svgs/FlagIcon';
import RWBUserImages from '../RWBUserImages';
import TextInput from '../TextInput';
import TextArea from '../TextArea';
import {userProfile} from '../../../../shared/models/UserProfile';
import ExpansionPanel from './ExpansionPanel';
import RadioButtons from './RadioButtons';
import {isNullOrEmpty} from '../../../../shared/utils/Helpers';
import {rwbApi} from '../../../../shared/apis/api';
import Loading from '../Loading';
import moment from 'moment';
import {MILITARY_STATUSES} from '../../../../shared/constants/MilitaryStatusSlugs';
import imageHandler from '../ImageHandler';
import {
  logCoverPhoto,
  logProfilePhoto,
  logUpdateMilitaryService,
  logUpdateProfile,
} from '../../../../shared/models/Analytics';
import MenuButton from './MenuButton';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';
import { ACCOUNT_ERRORS, UPLOADING_IMAGE_ERROR } from '../../../../shared/constants/ErrorMessages';
import { projectConfig } from '../../../../shared/project-info/projectConfig';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    boxShadow: '0px 0px 0px 0px',
    position: 'sticky',
  },
  menuButton: {
    color: 'var(--white)',
  },
  title: {
    color: 'var(--white)',
    textTransform: 'capitalize',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'var(--primary)',
    height: 64,
  },
  button: {
    color: 'white',
    textTransform: 'capitalize',
  },
  iconLabelWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    fontWeight: 'bold',
    color: 'var(--grey)',
  },
  iconLabelWrapperSelected: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    fontWeight: 'bold',
    color: 'var(--primary)',
  },
  indicator: {
    backgroundColor: 'var(--primary)',
    border: null,
    borderColor: null,
  },
}));

const EditMyProfile = () => {
  const user = useMemo(() => userProfile.getUserProfile(), []);
  // if the user does not have an ets date, passing undefined creates a moment of now, which we want to avoid
  const etsDate = moment(user.military_ets || 'invalid');
  const ets_date_valid = etsDate.isValid();
  const [isLoading, setIsLoading] = useState(true);
  const [profileImage, setProfileImage] = useState(user.profile_photo_url);
  const [profileImageUri, setProfileImageUri] = useState();
  const [coverImage, setCoverImage] = useState(user.cover_photo_url);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [firstName, setFirstName] = useState(user.first_name);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastName, setLastName] = useState(user.last_name);
  const [lastNameError, setLastNameError] = useState(false);
  const [bioValue, setBioValue] = useState(user.profile_bio);
  const [bioError, setBioError] = useState("")
  const [militaryStatus, setMilitaryStatus] = useState(user.service_info?.status);
  const [militaryFamily, setMilitaryFamily] = useState(
    user.military_family_member,
  );
  const [militaryBranch, setMilitaryBranch] = useState(user.service_info?.service_type);
  const [militaryETSMonth, setMilitaryETSMonth] = useState(
    ets_date_valid ? etsDate.format('MMMM') : '',
  );
  const [militaryETSDay, setMilitaryETSDay] = useState(
    ets_date_valid ? etsDate.format('DD') : '',
  );
  const [militaryETSYear, setMilitaryETSYear] = useState(
    ets_date_valid ? etsDate.format('YYYY') : '',
  );
  const [militaryETSError, setMilitaryETSError] = useState(false);
  const [militaryRank, setMilitaryRank] = useState(user.military_rank);
  const [rankError, setRankError] = useState(false);
  const [disability, setDisability] = useState(user.service_info?.culturally_and_linguistically_diverse);
  const [combatZone, setCombatZone] = useState(user.combat_zone);
  const [combatZoneOperation, setCombatZoneOperation] = useState(
    user.combat_deployment_operations,
  );
  const [chapterData, setChapterData] = useState([]);
  const [preferredChapter, setPreferredChapter] = useState(
    user.preferred_chapter,
  );
  const [newsletterSubscription1, setNewsletterSubscription1] = useState(
    user.newsletter_subscription?.[0],
  );
  const [newsletterSubscription2, setNewsletterSubscription2] = useState(
    user.newsletter_subscription?.[1],
  );
  const [expandedMilitaryPanel, setExpandedMilitaryPanel] = useState(false);

  const MAX_BIO_CHARS = 250;

  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    setIsLoading(false);
    // rwbApi
    //   .getChapters()
    //   .then((jsonBody) => {
    //     let {data} = jsonBody;
    //     setChapterData(data);
    //     setIsLoading(false);
    //   })
    //   .catch(() => {
    //     errorAlert(ACCOUNT_ERRORS.CHAPTERS);
    //   });
  }, []);

  const addImageHandler = async (e, type) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    if (file) {
      // needs support for iOS devices as they are 'image/' type,
      // but are not selectable from the html accept value
      if (!file.type.includes('image/')) {
        window.alert('Invalid file format: please upload an image.');
        return;
      } else if (type === 'cover') {
        logCoverPhoto();
        setCoverImageFile(file);
        reader.readAsDataURL(file);
        reader.onload = () => {
          setCoverImage(reader.result);
        };
      } else {
        logProfilePhoto();
        setProfileImageUri(file);
        reader.readAsDataURL(file);
        reader.onload = () => {
          setProfileImage(reader.result);
        };
      }
    }
  };

  const uploadImage = async (file, type) => {
    try {
      return await imageHandler(file, type);
    } catch (error) {
      errorAlert(error.message);
    }
  };

  const clearWarnings = () => {
    setExpandedMilitaryPanel(false);
    setFirstNameError(false);
    setLastNameError(false);
    setBioError("");
    setMilitaryETSError(false);
    setRankError(false);
  };

  const handleChapterLog = () => {
    let changed = false;
    if (
      preferredChapter.id?.toString() !== user.preferred_chapter?.id.toString()
    )
      changed = true;
    if (
      newsletterSubscription1?.id?.toString() !==
      user.newsletter_subscription[0]?.id.toString()
    )
      changed = true;
    if (
      newsletterSubscription2?.id?.toString() !==
      user.newsletter_subscription[1]?.id.toString()
    )
      changed = true;
  };

  const handleMilitaryLog = () => {
    let changed = false;
    if (militaryStatus !== user.military_status) changed = true;
    if (militaryBranch !== user.military_branch) changed = true;
    if (disability !== user.has_disability) changed = true;
    if (combatZone !== user.combat_zone) changed = true;
    if (combatZoneOperation !== user.combat_deployment_operations)
      changed = true;
    if (militaryRank !== user.military_rank) changed = true;
    if (etsDate.format('YYYY-MM-DD') !== user.military_ets) changed = true;
    if (militaryFamily !== user.military_family_member) changed = true;
    if (changed) logUpdateMilitaryService();
  };

  const updateProfile = async () => {
    setIsLoading(true);
    clearWarnings();
    let hasError = false;
    if (isNullOrEmpty(firstName)) {
      setFirstNameError(true);
      hasError = true;
    }
    if (!projectConfig.allowBlankLastName && isNullOrEmpty(lastName)) {
      setLastNameError(true);
      hasError = true;
    }
    if(isNullOrEmpty(bioValue))
      {
        setBioError("This field is required.")
        hasError = true;
      }
    if (bioValue && bioValue.length > MAX_BIO_CHARS) {
      setBioError("EXCEEDED THE PROFILE BIO LIMIT")
      hasError = true;
    }
    // if (
    //   militaryStatus === MILITARY_STATUSES.veteran &&
    //   (!militaryETSMonth || !militaryETSDay || !militaryETSYear)
    // ) {
    //   setExpandedMilitaryPanel(true);
    //   setMilitaryETSError(true);
    //   hasError = true;
    // }
    // if (militaryStatus !== MILITARY_STATUSES.civilian && !militaryRank) {
    //   setExpandedMilitaryPanel(true);
    //   setRankError(true);
    //   hasError = true;
    // }
    // check all fields for errors, then return.
    if (hasError) {
      setIsLoading(false);
      return;
    }
    // const etsdDate = moment(
    //   `${militaryETSMonth} ${militaryETSDay} ${militaryETSYear}`,
    //   'MMMM DD YYYY',
    // );
    let payload = {
      first_name: firstName,
      last_name: lastName,
      profile_bio: bioValue || null,
      cover_photo_url: coverImage,
      service_info: {
        status: militaryStatus,
        culturally_and_linguistically_diverse: disability,
        service_type: militaryBranch,
      }
    };
    if (coverImageFile) {
      const result = await uploadImage(coverImageFile, 'cover');
      if (result) payload.cover_photo_url = result;
    }
    if (profileImageUri) {
      const result = await uploadImage(profileImageUri, 'profile');
      if (result) payload.profile_photo_url = result;
    }
    
    await rwbApi.putUser(JSON.stringify(payload));
    logUpdateProfile();
    setIsLoading(false);
    history.goBack();
  };

  return (
    <Paper className={classes.root}>
      {isLoading && (
        <Loading size={100} color={'var(--white)'} loading={true} right />
      )}
      <Toolbar className={classes.toolbar}>
        <IconButton
          onClick={() => history.goBack()}
          className={classes.menuButton}
          color="inherit">
          <XIcon tintColor={'var(--white)'} />
        </IconButton>
        <p className="title">Edit Profile</p>
        <IconButton
          onClick={updateProfile}
          className={classes.menuButton}
          color="inherit">
          <CheckIcon tintColor={'var(--white)'} />
        </IconButton>
      </Toolbar>
      <div className={styles.userImageContainer}>
        <RWBUserImages
          profilePhoto={profileImage}
          coverPhoto={coverImage}
          edit={true}
          onChangeProfile={(e) => addImageHandler(e, 'profile')}
          onChangeCover={(e) => addImageHandler(e, 'cover')}
        />
        <div className={styles.contentContainer}>
          <TextInput
            label={'First Name'}
            error={firstNameError ? 'This field is required.' : ''}
            value={firstName}
            onValueChange={(e) => setFirstName(e.target.value)}
          />
          <RadioButtons />
          <TextInput
            label={'Last Name'}
            error={lastNameError ? 'This field is required.' : ''}
            value={lastName}
            onValueChange={(e) => setLastName(e.target.value)}
          />
          {/* <div className={styles.preferredChapterContainer}> */}
            {/* <MenuButton
              label="Local Chapter"
              data={chapterData}
              userProp={user.preferred_chapter.name}
              setMilitaryValue={setPreferredChapter}
            /> */}
            {/* <p className={styles.label}>Local Chapter</p>
            <p>{user.preferred_chapter.name}</p> */}
          {/* </div> */}
          <TextArea
            label={'Profile Bio'}
            placeholder={'Enter Profile Bio'}
            error={bioError}
            maxChar={MAX_BIO_CHARS}
            value={bioValue || ''}
            onChange={(value) => setBioValue(value)}
          />
        </div>
        <div onClick={() => setExpandedMilitaryPanel(!expandedMilitaryPanel)}>
          {/* <ExpansionPanel
            expanded={expandedMilitaryPanel}
            label={projectConfig.profileInfoTitle}
            Icon={FlagIcon}
            user={user}
            militaryStatus={militaryStatus}
            militaryFamily={militaryFamily}
            militaryBranch={militaryBranch}
            militaryRank={militaryRank}
            disability={disability}
            combatZone={combatZone}
            combatZoneOperation={combatZoneOperation}
            militaryETSMonth={militaryETSMonth}
            militaryETSDay={militaryETSDay}
            militaryETSYear={militaryETSYear}
            militaryETSError={militaryETSError}
            rankError={rankError}
            setMilitaryStatus={setMilitaryStatus}
            setMilitaryFamily={setMilitaryFamily}
            setMilitaryBranch={setMilitaryBranch}
            setMilitaryRank={setMilitaryRank}
            setDisability={setDisability}
            setMilitaryETSMonth={setMilitaryETSMonth}
            setMilitaryETSDay={setMilitaryETSDay}
            setMilitaryETSYear={setMilitaryETSYear}
            setCombatZone={setCombatZone}
            setCombatZoneOperation={setCombatZoneOperation}
          /> */}
          {projectConfig.profileInfoTitle && <div className={styles.contentContainerBox}>
            <Typography className={classes.heading} onClick={() => {
              history.push({
                pathname: `/profile/edit/profileextrainfoupdate`,
                state: {
                  value: user,
                }
              })
            }}>
              <FlagIcon className={classes.svg} /> {projectConfig.profileInfoTitle}
              <span>

                <ChevronRightIcon />
              </span>
            </Typography>
          </div>}
        </div>
      </div>
    </Paper>
  );
};

export default EditMyProfile;
